import { msg } from '@lingui/macro';

export const NEWS_SECTIONS_TITLES = {
  '': msg`Actualités`,
  search: msg`Actualités - Recherche`,
};
